import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { StyledImgDivContainerProps } from '../../../shared/dto/StyleCompRepository';
import { convertS3UrlToCloudFrontUrl } from '../../../shared/aws/awsHelper';
import OptimizedMoleculeImgDivContainer from '../../../shared/component/molecule/OptimizedMoleculeImgDivContainer';
import { ProjectSimpleData } from '../../../shared/dto/EntityRepository';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import ProjectEditControllerMobile from './ProjectEditControllerMobile';
import { usePageOwnerIdentityStore } from '../../../shared/store/pageOwnerIdentityStore';

interface ProjectSimpleProps {
  data: ProjectSimpleData;
}

const ProjectSimpleMobile: React.FC<ProjectSimpleProps> = ({ data }) => {
  const { isEditMode } = useEditMode();
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const projectDetailPath = pageOwner ? `/@${pageOwner.handle}/projects/${data.id}` : '#';

  const handleProjectLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isEditMode || !pageOwner) {
      e.preventDefault();
    }
  }

  return (
    <ProjectSimpleComp>
      <ContentWrapper to={projectDetailPath} onClick={handleProjectLinkClick} $isPublic={data.isPublic}>
        <OptimizedMoleculeImgDivContainer
          backgroundImg={convertS3UrlToCloudFrontUrl(data.originUrl)}
          StyledImgDivContainer={ProjectRepresent}
          $focusX={data.focusX ?? 0.5}
          $focusY={data.focusY ?? 0.5}
        />
        <ProjectSimpleInfo>
          <ProjectSimpleTitle>
            <ProjectSimpleYear>{data.projectYear ? `${data.projectYear}` : ''}</ProjectSimpleYear>
            {data.title}
          </ProjectSimpleTitle>
        </ProjectSimpleInfo>
      </ContentWrapper>
      <ProjectEditControllerMobile
        projectId={data.id}
        isPublic={data.isPublic}
      />
    </ProjectSimpleComp>
  );
};

const ProjectSimpleComp = styled.div`
  position: relative;

  width: 100%;
  padding: 0px clamp(18px, 5vw, 24px);
  padding-top: 4px;
  margin-bottom: 12px;
`;

const ContentWrapper = styled(Link)<{ $isPublic: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
  ${({ $isPublic }) => !$isPublic && `
    opacity: 0.6;
  `}
`;

const ProjectSimpleInfo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const ProjectSimpleYear = styled.span`
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_01};
  font-style: italic;
`;

const ProjectSimpleTitle = styled.h2`
  text-align: end;
  ${({ theme }) => theme.typography.Body_01_1};
`;

const ProjectRepresent = styled.div<StyledImgDivContainerProps & {
  $focusX: number;
  $focusY: number;
}>`
  width: 100%;
  height: 180px;

  background-image: url(${props => props.$backgroundImg});
  background-size: cover;
  background-position: ${({ $focusX, $focusY }) => `${$focusX * 100}% ${$focusY * 100}%`};
  position: relative;
  margin-bottom: 4px;
`;

export default ProjectSimpleMobile;
